import React, {useEffect} from 'react';
import {setLang} from "../helpers/api_helper";

const NonAuthLayout = ({ children }) => {
    useEffect(() => {
        const currentLanguage = localStorage.getItem("I18N_LANGUAGE");
        setLang(currentLanguage);
    }, []);
    return (
        <div>
            {children}
        </div>
    );
};

export default NonAuthLayout;
